import React, { memo } from "react";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import InputNumberField from "Components/formControls/HookFields/InputNumberField";
import PhoneInput from "react-phone-number-input/input";

const ContactNumber = memo(() => {
  const { t } = useTranslation();
  const {
    setValue,
    watch,
    setError,
    formState: { errors },
    clearErrors
  } = useFormContext();
  const { information, disabledView } = watch();

  const validationMessage = () => {
    !information?.contactNumber
      ? setError(`information.contactNumber`, {
          type: "custom",
          message: "Please enter valid contact number"
        })
      : clearErrors("information.contactNumber");
  };
  return (
    <div>
      <PhoneInput
        inputProps={{"data-testid": "input-change"}}
        id={"information.contactNumber"}
        name={"information.contactNumber"}
        companyContactNumber={information?.contactNumber}
        value={information?.contactNumber}
        onChange={e => {
          setValue("information.contactNumber", e);
          validationMessage();
        }}
        disabled={disabledView}
        defaultCountry="US"
        onBlur={validationMessage}
        label={t("companySetup.information.contactNumber.label")}
        placeholder={t("companySetup.information.contactNumber.placeholder")}
        inputComponent={InputNumberField}
        error={get(errors, "information.contactNumber.message", "")}
      />
    </div>
  );
});

export default ContactNumber;
